import { environment, inWindow } from '@/config';
import { wait } from '@/api/util';
import { inWindowTool } from './../../../utils/inWindow';
let expiredCount = 0;
const maxExpiredCount = 20;
let resetCount = 0;
const maxResetCount = 15;
const localHost = ['su-desktop-web-2.cowork.netease.com', 'su-desktop-web.cowork.netease.com', 'su-desktop-web-1.cowork.netease.com'];
const isLocal = inWindow() && localHost.some(v => window.location.origin.includes(v));
let hasAddUnLoadEvent = false;
export default class SiriusBDSocket {
    constructor(systemApi, xhr, version) {
        this.callbacks = [];
        this.isConnectingNode = false;
        this.isConnecting = false;
        this.socket = null;
        this.systemApi = systemApi;
        this.xhr = xhr;
        this.version = version;
    }
    addSubscribe(callback) {
        this.callbacks.push(callback);
    }
    removeAllSubscribe() {
        this.callbacks = [];
    }
    getBDProduct() {
        return process.env.BUILD_ISEDM ? 'waimao' : 'sirius';
    }
    getBDAppPlatform() {
        if (process.env.BUILD_ISELECTRON) {
            if (inWindowTool() && window.process) {
                switch (window.process.platform) {
                    case 'linux':
                        return 'pc';
                    case 'darwin':
                        return 'mac';
                    case 'win32':
                        return 'pc';
                }
            }
            return 'web';
        }
        return 'web';
    }
    async getBdSocketToken() {
        const defautlToken = '';
        try {
            const appPlatform = this.getBDAppPlatform();
            const data = await this.xhr
                .post(this.systemApi.getUrl('getPushToken'), {
                product: this.getBDProduct(),
                deviceId: this.systemApi.getSimpleDeviceInfo(true)._deviceId,
                appPlatform: appPlatform === 'pc' ? 'windows' : appPlatform,
                appVersion: this.version,
            }, {
                contentType: 'json',
            })
                .then(res => res.data);
            if (data && data.data && data.data.fp) {
                const token = data.data.fp;
                const shouldUseBd = data.data.pcChannelType === 2;
                return {
                    token,
                    shouldUseBD: shouldUseBd,
                };
            }
            return defautlToken;
        }
        catch (ex) {
            if (!isLocal) {
                console.error('ex', ex);
            }
            return '';
        }
    }
    resetStatus() {
        this.isConnectingNode = false;
        this.isConnecting = false;
    }
    destorySocket() {
        if (this.socket) {
            try {
                this.socket.unSubscribeAll();
                this.socket.close();
            }
            catch (ex) {
                if (!isLocal) {
                    console.error('destory socket');
                }
            }
            this.socket = null;
        }
    }
    getIsConnecting() {
        return this.isConnecting;
    }
    async initBdSocket(token) {
        try {
            if (this.isConnectingNode || this.isConnecting)
                return;
            this.isConnectingNode = true;
            this.destorySocket();
            const tokenStr = token ? token : await this.getBdSocketToken();
            if (tokenStr) {
                const isTest = environment !== 'prod';
                import('@mail/bd-socket').then(res => {
                    const { BDSocketWeb } = res;
                    const socket = new BDSocketWeb({
                        debug: isTest,
                        product: this.getBDProduct(),
                        osVersion: this.version,
                        clientType: this.getBDAppPlatform(),
                        deviceId: this.systemApi.getSimpleDeviceInfo(true)._deviceId,
                        token: tokenStr,
                        useTestStat: isTest,
                        reconnectConfig: {
                            duration: 1,
                            limit: 300,
                        },
                    });
                    socket.on('connect_error', ev => {
                        if (!isLocal) {
                            console.error('connect_error', ev);
                        }
                        this.resetStatus();
                    });
                    socket.on('connect_timeout', ev => {
                        this.resetStatus();
                        if (!isLocal) {
                            console.error('connect_timeout', ev);
                        }
                    });
                    socket.on('connect', ev => {
                        this.isConnecting = true;
                        this.isConnectingNode = false;
                        expiredCount = 0;
                        if (!isLocal) {
                            console.error('connected', ev);
                        }
                    });
                    socket.on('disconnect', ev => {
                        this.resetStatus();
                        if (!isLocal) {
                            console.error('disconnect-ev', ev);
                        }
                    });
                    socket.on('token_expired', async (ev) => {
                        if (!isLocal) {
                            console.error('token_expired-ev', ev);
                        }
                        expiredCount++;
                        if (expiredCount >= maxExpiredCount) {
                            resetCount++;
                            if (resetCount > maxResetCount) {
                                return;
                            }
                            const waitMinutes = Math.floor(Math.random() * 5 + 6);
                            await wait(waitMinutes * 60 * 1000);
                            expiredCount = 0;
                        }
                        await wait(expiredCount * 1000 * 2);
                        const tokenInfo = await this.getBdSocketToken();
                        if (tokenInfo && tokenInfo.token && socket) {
                            socket.refreshToken(tokenInfo.token);
                        }
                    });
                    socket.on('reconnect', () => {
                        this.isConnecting = true;
                        this.isConnectingNode = false;
                    });
                    socket.on('reconnect_error', () => {
                        this.resetStatus();
                    });
                    socket.on('reconnect_failed', () => {
                        this.resetStatus();
                    });
                    socket.on('retrynodes_failed', data => {
                        this.resetStatus();
                        if (!isLocal) {
                            console.error('retrynodes_failed-error', data);
                        }
                    });
                    socket.subscribe((payload) => {
                        let payLoadObj = payload && typeof payload.payload === 'string'
                            ? payload.payload
                            : payload && payload.payload && typeof payload.payload.body === 'string'
                                ? payload.payload.body
                                : payload;
                        if (!payLoadObj)
                            return {};
                        if (this.callbacks && this.callbacks.length) {
                            this.callbacks.forEach(cb => {
                                try {
                                    return cb(payLoadObj);
                                }
                                catch (ex) {
                                    if (!isLocal) {
                                        console.error('payload-ex', ex);
                                    }
                                }
                            });
                        }
                        return {};
                    });
                    this.isConnecting = true;
                    socket.connect();
                    this.socket = socket;
                    if (!hasAddUnLoadEvent) {
                        window.addEventListener('beforeunload', () => {
                            var _a;
                            try {
                                (_a = this.socket) === null || _a === void 0 ? void 0 : _a.close();
                            }
                            catch (ex) {
                                console.error('beforeunload-ex', ex);
                            }
                        });
                        hasAddUnLoadEvent = true;
                    }
                    return true;
                });
            }
            else {
                this.isConnectingNode = false;
                this.isConnecting = false;
            }
            return false;
        }
        catch (ex) {
            if (!isLocal) {
                console.error('initBdSocket-ex');
            }
            return false;
        }
    }
}
